<template>
  <v-flex class="billPayments" data-qa="billpayments-flex-3402s">
    <v-window v-model="step" data-qa="billpayments-window-s83xpj">
      <v-window-item v-if="newBillerTemplate" :value="1" data-qa="billpayments-window-item-qxxli6">
        <biller-selection></biller-selection>
      </v-window-item>
      <v-window-item :value="2" data-qa="billpayments-window-item-twxlmi">
        <v-layout wrap class="ml-2 billPayments--gradientBGposition" data-qa="billpayments-layout-ub1a76">
          <v-flex
            xs12
            sm12
            md12
            lg12
            xl12
            :style="{ background: dashboardGradient, height: '180px' }"
           data-qa="billpayments-flex-3smseu">
            <v-container class="billPayments--title-padding" data-qa="billpayments-container-mq1g6r">
              <v-flex xs12 sm12 md12 lg12 xl12 data-qa="billpayments-flex-zokp2r">
                <v-row no-gutters data-qa="billpayments-row-jr1i">
                  <v-layout row wrap class="pb-2 pl-12" data-qa="billpayments-layout-ev0b4">
                    <div class="pt-3" data-qa="billpayments-div-5k9dzq">
                    <v-avatar :tile="false" size="35" color="white" data-qa="billpayments-avatar-ql60lj">
                      <v-icon :color="primaryColor" data-qa="billpayments-icon-0yfb6">mdi-receipt</v-icon>
                    </v-avatar>
                    </div>
                <v-flex xs9 sm9 md9 lg9 xl9 class="pt-4 pl-2" data-qa="billpayments-flex-byhsi">
                  <v-row no-gutters data-qa="billpayments-row-gmixel">
                    <font class="text-h5 font-weight-light white--text">
                      {{ $t("billPayments.title")}}</font
                    >
                  </v-row>
                </v-flex>
              </v-layout>
                </v-row>
              </v-flex>
            </v-container>
          </v-flex>
        </v-layout>
        <v-flex
          xs12
          sm12
          md12
          lg10
          xl10
          class="billPayments--content-padding billPayments--overlayCardFlex"
         data-qa="billpayments-flex-rcaspp">
          <v-layout row wrap class="billPayments--content-padding" data-qa="billpayments-layout-hrhcim">
            <v-flex
              v-if="newBillerTemplate"
              sm12
              xs12
              md12
              lg12
              xl12
              class="hidden-lg-and-up pb-2"
             data-qa="billpayments-flex-oasdjj">
              <v-btn
                @click="navigateToHistory()"
                color="white"
                class="text-none px-5 py-2 px-4"
                outlined
                 data-qa="billpayments-btn-vkdpus">{{ $t("billPayments.billPaymentHistory") }}</v-btn
              >
            </v-flex>
            <v-flex v-else sm12 xs12 md12 lg12 xl12 class="hidden-lg-and-up pb-2" data-qa="billpayments-flex-53zy0p">
              <v-btn
                v-if="isInitiateBillPaymentPermitted"
                @click="newBillPayment()"
                color="white"
                class="text-none px-5 py-2 px-4"
                outlined
                 data-qa="billpayments-btn-yozcic">{{ $t("billPayments.newBillPaymentLabel") }}</v-btn
              >
            </v-flex>
            <v-flex xs12 sm11 md10 lg10 xl10 class="pt-0 pb-0" data-qa="billpayments-flex-uny6w6">
              <Form
                v-if="renderComponent"
                :config="{
                  label: newBillerTemplate
                    ? newBillerFormHeader
                    : repeatBillPaymentHeader,
                  icon: 'mdi-pencil',
                  name: 'BillPayments',
                  isEnabled: true,
                  toolbar: true,
                  form: schema.billPaymentsSchema
                }"
              >
                <div slot="formActions" class="font-weight-bold" data-qa="billpayments-div-svrsse">
                  <v-layout row data-qa="billpayments-layout-su9l4q">
                    <v-flex xs5 sm5 md5 lg3 xl5 class="py-2 px-1" data-qa="billpayments-flex-7oo9c7">
                      <v-btn
                        class="text-capitalize py-2 px-4"
                        :color="primaryColor"
                        elevation="2"
                        outlined
                        @click="navigateWindow()"
                        style="margin-left: 24px;"
                         data-qa="billpayments-btn-wte7ka">{{ $t("billPayments.back") }}</v-btn
                      >
                    </v-flex>
                    <v-flex xs5 sm5 md5 lg5 xl5 class="py-2 px-1" data-qa="billpayments-flex-pw637q">
                      <v-btn
                        class="text-capitalize white--text py-2 px-4"
                        :color="primaryColor"
                        :disabled="valid"
                        elevation="2"
                        @click="calculateCharges()"
                        style="margin-left: -60px;"
                         data-qa="billpayments-btn-yh8db">{{ $t("billPayments.reviewPaymentBtn") }}</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </div>
              </Form>
            </v-flex>
            <v-flex
              v-if="newBillerTemplate"
              sm12
              xs12
              md2
              lg2
              xl2
              class="hidden-md-and-down billHistory--newBill pl-10"
             data-qa="billpayments-flex-wmahsx">
              <v-btn
                @click="navigateToHistory()"
                color="white"
                class="text-none px-4 py-2"
                outlined
                 data-qa="billpayments-btn-ectbp">{{ $t("billPayments.billPaymentHistory") }}</v-btn
              >
            </v-flex>
            <v-flex
              v-else
              sm12
              xs12
              md2
              lg2
              xl2
              class="hidden-md-and-down billHistory--newBill pl-10"
             data-qa="billpayments-flex-sgff8t">
              <v-btn
                v-if="isInitiateBillPaymentPermitted"
                @click="newBillPayment()"
                color="white"
                class="text-none px-4 py-2"
                outlined
                 data-qa="billpayments-btn-zsx273">{{ $t("billPayments.newBillPaymentLabel") }}</v-btn
              >
            </v-flex>
          </v-layout>
        </v-flex>
      </v-window-item>
      <v-window-item :value="3" data-qa="billpayments-window-item-o5zema">
        <v-flex data-qa="billpayments-flex-2910uj">
          <payments-review-screen
            v-if="reviewScreen"
            @handle="step = 2"
            :configData="{ chargeInfo }"
            :displayData="display"
            :chargeResponse="chargeResponse"
          ></payments-review-screen>
        </v-flex>
      </v-window-item>
      <ConfirmExit v-if="isLeavingRoute" v-on:isLeavingRoute="proceedLeave" v-on:isNotLeavingRoute="cancelLeave"/>
    </v-window>
  </v-flex>
</template>
<script>
import '@/styles/pages/billPayments.scss'
import CommonService from '@/service/commonService.js'
import getFormConfig from '@/util/formUtility.js'
import preload from '@/util/preload'
import event from '@/util/event'
import PaymentsReviewScreen from './PaymentsReviewScreen.vue'
import BillerSelectionVue from './BillerSelection.vue'
import ConfirmExit from '@/components/common/ConfirmExit.vue'
import store from '@/core/store'
import moment from 'moment'
import {
  required
} from '@/core/_helpers/validationRules'
export default {
  name: 'BillPayments',
  components: {
    Form: () => import('@/components/DOB-Form/Form.vue'),
    PaymentsReviewScreen,
    'biller-selection': BillerSelectionVue,
    ConfirmExit
  },
  props: {
    config: {
      type: Object,
      default: undefined
    }
  },
  data () {
    return {
      schema: {
        billPaymentsSchema: { exists: true }
      },
      listOfAccounts: [],
      validAccountsList: [],
      valid: false,
      reviewScreen: true,
      chargePayload: {},
      display: {},
      chargeResponse: {},
      chargeInfo: '',
      step: 1,
      billerData: '',
      dueDate: '',
      additionalFields: [],
      businessDate: '',
      newBillerTemplate: true,
      newBillerFormHeader: '',
      repeatBillPaymentHeader: '',
      additionalDescription: [],
      additionalFormValues: [],
      renderComponent: true,
      existingFields: [],
      accountField: {},
      customDataMap: [],
      isdCode: '',
      billerCurrency: '',
      accountsExist: false,
      billerDetails: '',
      isLeavingRoute: false,
      isLogout: false,
      loanInfo: '',
      PaymentCompleted: false,
      formCheck: '',
      isInitiateBillPaymentPermitted: false,
      isSmeLogin: JSON.parse(sessionStorage.getItem('isSmeLogin')),
      enableRoleBasedAccess: this.$appSettings.defaultConfigurations.smeRoles.enableRoleBasedAccess
    }
  },
  async created () {
    if (store.getters['profileStore/profileData'].customerDetails && store.getters['profileStore/profileData'].customerDetails.SMS) {
      this.isdCode = store.getters['profileStore/profileData'].customerDetails.SMS.isdCode
    }
    await this.getFormData(`BillPayments-${this.$i18n.locale}`)
    this.listOfAccounts = []
    this.accountsExist = false
    this.getListofAccounts()
    // Fetch Permissions for SME Users
    const permissions = store.getters['profileStore/profileData']?.permissions
    this.isInitiateBillPaymentPermitted = (this.isSmeLogin && this.enableRoleBasedAccess) ? permissions?.includes('INITIATE_BILL_PAYMENTS') : true
    event.$on('checkAccountBalance', (arg, action) => {
      this.validAccountsList.forEach((key, index) => {
        if (arg.e.data.debitAccountNumber === key.value) {
          if (Number(arg.e.data.billAmount) > Number(key.balance)) {
            this.schema.billPaymentsSchema.schema.debitAccountNumber['error-messages'] = 'Insufficient funds available to process payment.'
          } else {
            this.schema.billPaymentsSchema.schema.debitAccountNumber['error-messages'] = ''
          }
        }
      })
      if (this.newBillerTemplate) {
        if ((Number(arg.e.data.billAmount) !== 0) && this.billerData && Number(this.billerData[0].minimumAmountAllowed) && (Number(arg.e.data.billAmount) < Number(this.billerData[0].minimumAmountAllowed)) && this.newBillerTemplate) {
          this.schema.billPaymentsSchema.schema.billAmount['error-messages'] = `Min ${this.$formatter.currency.getCurrencySymbol(this.billerCurrency)} ${this.billerData[0].minimumAmountAllowed} - Max ${this.$formatter.currency.getCurrencySymbol(this.billerCurrency)} ${this.billerData[0].maxAmountAllowed}`
        } else if ((Number(arg.e.data.billAmount) !== 0) && this.billerData && Number(this.billerData[0].maxAmountAllowed) && (Number(arg.e.data.billAmount) > Number(this.billerData[0].maxAmountAllowed)) && this.newBillerTemplate) {
          this.schema.billPaymentsSchema.schema.billAmount['error-messages'] = `Min ${this.$formatter.currency.getCurrencySymbol(this.billerCurrency)} ${this.billerData[0].minimumAmountAllowed} - Max ${this.$formatter.currency.getCurrencySymbol(this.billerCurrency)} ${this.billerData[0].maxAmountAllowed}`
        } else if ((Number(arg.e.data.billAmount) === 0) && arg.e.data.billAmount !== '') {
          this.schema.billPaymentsSchema.schema.billAmount['error-messages'] = 'Invalid amount'
        } else {
          this.schema.billPaymentsSchema.schema.billAmount['error-messages'] = ''
        }
      }
      if (!this.newBillerTemplate) {
        if ((Number(arg.e.data.billAmount) !== 0) && this.billerDetails && Number(this.billerDetails.minimumAmountAllowed) && (Number(arg.e.data.billAmount) < Number(this.billerDetails.minimumAmountAllowed)) && !this.newBillerTemplate) {
          this.schema.billPaymentsSchema.schema.billAmount['error-messages'] = `Min ${this.$formatter.currency.getCurrencySymbol(this.billerCurrency)} ${this.billerDetails.minimumAmountAllowed} - Max ${this.$formatter.currency.getCurrencySymbol(this.billerCurrency)} ${this.billerDetails.maxAmountAllowed}`
        } else if ((Number(arg.e.data.billAmount) !== 0) && this.billerDetails && Number(this.billerDetails.maxAmountAllowed) && (Number(arg.e.data.billAmount) > Number(this.billerDetails.maxAmountAllowed)) && !this.newBillerTemplate) {
          this.schema.billPaymentsSchema.schema.billAmount['error-messages'] = `Min ${this.$formatter.currency.getCurrencySymbol(this.billerCurrency)} ${this.billerDetails.minimumAmountAllowed} - Max ${this.$formatter.currency.getCurrencySymbol(this.billerCurrency)} ${this.billerDetails.maxAmountAllowed}`
        } else if ((Number(arg.e.data.billAmount) === 0) && arg.e.data.billAmount !== '') {
          this.schema.billPaymentsSchema.schema.billAmount['error-messages'] = 'Invalid amount'
        } else {
          this.schema.billPaymentsSchema.schema.billAmount['error-messages'] = ''
        }
      }
    })
    event.$on('loadBillerTemplate', async (args) => {
      this.newBillerTemplate = true
      this.renderComponent = true
      if (this.additionalFields.length) {
        for (const i in this.schema.billPaymentsSchema.schema) {
          if (this.additionalFields.includes(i)) {
            delete this.schema.billPaymentsSchema.schema[i]
            delete this.schema.billPaymentsSchema.model[i]
          }
        }
      }
      this.billerData = store.getters['userStore/userData'].selectedBiller
      this.billerCurrency = store.getters['userStore/userData'].billerCurrency
      await this.getListofAccounts()
      this.businessDate = moment().format('YYYY-MM-DD')
      this.schema.billPaymentsSchema.schema.dueDate.min = this.businessDate
      this.schema.billPaymentsSchema.model.dueDate = this.$formatter.formatDate(this.businessDate)
      this.schema.billPaymentsSchema.schema.billAmount.prefix = this.$formatter.currency.getCurrencySymbol(this.billerCurrency)
      this.schema.billPaymentsSchema.schema.billAmount.hint = (this.billerData && Number(this.billerData[0].maxAmountAllowed) !== 0) ? `Min ${this.$formatter.currency.getCurrencySymbol(this.billerCurrency)} ${this.billerData[0].minimumAmountAllowed} - Max ${this.$formatter.currency.getCurrencySymbol(this.billerCurrency)} ${this.billerData[0].maxAmountAllowed}` : ''
      this.schema.billPaymentsSchema.schema.billAmount['persistent-hint'] = true
      this.schema.billPaymentsSchema.schema.billAmount['error-messages'] = ''
      this.newBillerFormHeader = this.billerData[0].companyDescription
        ? `${this.$t('billPayments.newBillPaymentLabel')} - ${this.billerData[0].companyDescription}` : this.$t('billPayments.newBillPaymentLabel')
      this.schema.billPaymentsSchema.model.companyId = this.billerData[0].companyCode
      if (this.billerData && this.billerData.length && this.billerData[0].additionalDataRequired && this.billerData[0].additionalDataRequired.length) {
        this.customDataMap = []
        this.billerData[0].additionalDataRequired.forEach((key, index) => {
          this.addDynamicFields(key, index)
        })
      }
      if (this.billerData && this.billerData.length && this.billerData[0].additionalDataRequired && this.billerData[0].additionalDataRequired.length) {
        this.additionalFields = []
        this.billerData[0].additionalDataRequired.forEach((key) => {
          this.additionalFields.push(key.fieldName)
        })
      } else {
        this.additionalFields = []
      }
      this.step++
    })
    if (this.config && this.config.paymentTemplate) {
      this.renderComponent = false
      this.newBillerTemplate = false
      this.loadPreviousTemplate()
    }
    event.$on('repeatBillerTemplate', (ele) => {
      this.config = ele
      this.loadPreviousTemplate()
    })
    event.$on('repeatTemplate', (arg1) => {
      // this.renderComponent = true
      setTimeout(() => {
        this.config = arg1
        this.config.paymentTemplate = true
        this.loadPreviousTemplate()
      }, 100)
    })
    event.$on('goToHistory', (repeatPayment) => {
      this.renderComponent = false
    })
    event.$on('updateSchema', () => {
      if (this.schema && this.schema.billPaymentsSchema && this.schema.billPaymentsSchema.model) {
        this.schema.billPaymentsSchema.model.debitAccountNumber = ''
        this.schema.billPaymentsSchema.model.customerId = ''
        this.schema.billPaymentsSchema.model.billAmount = ''
        this.schema.billPaymentsSchema.model.reference = ''
      }
    })
    event.$on('billerCheck', (arg) => {
      this.formCheck = true
    })
    event.$on('paymentCompleted', (arg) => {
      this.formCheck = false
      this.paymentCompleted = true
    })
    event.$on('depositPristineLogout', (arg) => {
      this.isLogout = arg
    })
  },
  beforeRouteLeave (to, from, next) {
    for (const i in this.schema.billPaymentsSchema.model) {
      if (this.schema.billPaymentsSchema.model[i]) {
        this.formCheck = true
      }
    }
    if (this.formCheck && !this.paymentCompleted) {
      if (this.to) {
        next()
      } else if (this.isLogout) {
        this.to = to
        this.isLeavingRoute = false
        this.$router.push('/login')
      } else {
        this.to = to
        this.isLeavingRoute = true
      }
    } else {
      next()
    }
  },
  methods: {
    cancelLeave () {
      this.isLeavingRoute = false
      this.to = null
    },
    proceedLeave () {
      this.isLeavingRoute = false
      this.$router.push(this.to)
    },
    addDynamicFields (key, index) {
      const obj = {
        type: 'text',
        readonly: false,
        label: key.fieldDescription,
        color: 'primaryColor',
        filled: true,
        dense: true,
        hidden: false,
        schemaRelation: [],
        schemaRelationRules: ['required'],
        'background-color': '#f0eff7',
        class: 'customField pr-2 pt-0 pl-2',
        autocomplete: 'off',
        rules: [],
        flex: {
          xs: 12,
          sm: 6,
          md: 6,
          lg: 6,
          xl: 6
        }
      }
      for (const i in this.schema.billPaymentsSchema.schema) {
        if (i === 'debitAccountNumber') {
          this.accountField = this.schema.billPaymentsSchema.schema[i]
          delete this.schema.billPaymentsSchema.schema[i]
        }
      }
      if (this.schema.billPaymentsSchema && this.schema.billPaymentsSchema.schema && this.schema.billPaymentsSchema.model) {
        Object.assign(this.schema.billPaymentsSchema.schema, { [key.fieldName]: obj })
        Object.assign(this.schema.billPaymentsSchema.model, { [key.fieldName]: '' })
        Object.assign(this.schema.billPaymentsSchema.schema, { debitAccountNumber: this.accountField })
      }
      if (key.isMandatory && this.schema.billPaymentsSchema.schema) {
        this.applyInputRules(this.schema.billPaymentsSchema.schema, key.fieldName, this.schema.billPaymentsSchema.schema[key.fieldName].schemaRelationRules, true)
      }
      if (!this.additionalDescription.includes(key.fieldDescription)) {
        this.additionalDescription.push(key.fieldDescription)
      }
      // Custom Data Fix
      if (this.config && this.config.chargeInfo && this.config.chargeInfo.additionalData && this.config.chargeInfo.additionalData[0]) {
        this.customDataMap[index] = { title: key.fieldDescription }
        this.customDataMap[index].subtitle = this.config.chargeInfo.additionalData[0]['custom-fields'][key.fieldName]
        this.customDataMap[index].name = key.fieldName
      } else {
        this.customDataMap[index] = { title: key.fieldDescription }
        this.customDataMap[index].subtitle = ''
        this.customDataMap[index].name = key.fieldName
      }
      if (this.newBillerTemplate) {
        if (key.fieldDescription === 'Customer Name') {
          this.schema.billPaymentsSchema.model[key.fieldName] = store.getters['profileStore/profileData'].customerDetails.firstName + ' ' + store.getters['profileStore/profileData'].customerDetails.lastName
        }
        if (key.fieldDescription === 'Mobile Number' && this.isdCode) {
          this.schema.billPaymentsSchema.model[key.fieldName] = store.getters['profileStore/profileData'].customerDetails.phoneNumber
          this.schema.billPaymentsSchema.schema[key.fieldName].prefix = this.isdCode
        }
      } else {
        if (this.config.chargeInfo && this.config.chargeInfo.additionalData && this.config.chargeInfo.additionalData[0] && this.config.chargeInfo.additionalData[0]['custom-fields']) {
          const additionalKeys = Object.keys(this.config.chargeInfo.additionalData[0]['custom-fields'])
          additionalKeys.forEach(element => {
            if (key.fieldName === element) {
              if (this.schema.billPaymentsSchema.model) {
                this.schema.billPaymentsSchema.model[key.fieldName] = this.config.chargeInfo.additionalData[0]['custom-fields'][element]
                if (key.fieldDescription === 'Mobile Number' && this.isdCode) {
                  this.schema.billPaymentsSchema.schema[key.fieldName].prefix = this.isdCode
                }
              }
            }
          })
        }
      }
    },
    applyInputRules (schema, schemaRelation, schemaRelationRules, value) {
      if (schema && schema[schemaRelation]) {
        const applicableRules = ['required']
        if (!('rules' in schema[schemaRelation])) {
          Object.assign(schema[schemaRelation], { rules: [] })
        }
        schemaRelationRules.forEach((rule, index) => {
          if (applicableRules.includes(rule)) {
            schema[schemaRelation].id = (value) ? rule : ''
            schema[schemaRelation].rules[index] = (value) ? required('Required') : ''
          }
        })
      }
    },
    validityCheck () {
      if (this.validAccountsList && this.validAccountsList.length) {
        this.validAccountsList.forEach((key, index) => {
          if (this.config.chargeInfo.debitAccountNumber === key.value) {
            if (Number(this.schema.billPaymentsSchema.model.billAmount) > Number(key.balance)) {
              this.schema.billPaymentsSchema.schema.debitAccountNumber['error-messages'] = 'Insufficient funds available to process payment.'
            } else {
              this.schema.billPaymentsSchema.schema.debitAccountNumber['error-messages'] = ''
            }
          }
        })
      }
    },
    loadPreviousTemplate () {
      this.billerCurrency = store.getters['userStore/userData'].billerCurrency
      event.$emit('templateCheck', true)
      // this.newBillerTemplate = false
      if (this.schema.billPaymentsSchema.schema) {
        this.reviewScreen = false
        for (const key in this.schema.billPaymentsSchema.model) {
          this.schema.billPaymentsSchema.model[key] = ''
        }
        if (this.config.paymentTemplate) {
          if (this.existingFields.length) {
            for (const i in this.schema.billPaymentsSchema.schema) {
              if (this.existingFields.includes(i)) {
                delete this.schema.billPaymentsSchema.schema[i]
                delete this.schema.billPaymentsSchema.model[i]
              }
            }
          }
          setTimeout(() => {
            this.newBillerTemplate = false
            this.businessDate = moment().format('YYYY-MM-DD')
            if (this.schema.billPaymentsSchema.schema) {
              this.schema.billPaymentsSchema.schema.dueDate.min = this.businessDate
              // this.schema.billPaymentsSchema.model.dueDate = this.$formatter.formatDate(this.businessDate)
              this.schema.billPaymentsSchema.model.companyId = this.config.chargeInfo.companyId
              this.schema.billPaymentsSchema.model.customerId = this.config.chargeInfo.customerId
              // this.schema.billPaymentsSchema.model.reference = this.config.chargeInfo.reference
              this.schema.billPaymentsSchema.schema.billAmount.prefix = this.$formatter.currency.getCurrencySymbol(this.billerCurrency)
              this.billerDetails = store.getters['userStore/userData'].repeatedBiller
              this.schema.billPaymentsSchema.schema.billAmount.hint = (this.billerDetails && Number(this.billerDetails.maxAmountAllowed) !== 0) ? `Min ${this.$formatter.currency.getCurrencySymbol(this.billerCurrency)} ${this.billerDetails.minimumAmountAllowed} - Max ${this.$formatter.currency.getCurrencySymbol(this.billerCurrency)} ${this.billerDetails.maxAmountAllowed}` : ''
              this.schema.billPaymentsSchema.schema.billAmount['persistent-hint'] = true
              this.schema.billPaymentsSchema.schema.billAmount['error-messages'] = ''
              this.schema.billPaymentsSchema.model.billAmount = this.config.chargeInfo.billAmount
              this.schema.billPaymentsSchema.model.debitAccountNumber = this.config.chargeInfo.debitAccountNumber
              this.validityCheck()
            }
            this.repeatBillPaymentHeader = 'Repeat Payment' + ' ' + '-' + ' ' + this.config.chargeInfo.companyId
            setTimeout(() => {
              this.step--
              if (this.schema.billPaymentsSchema.schema) {
                this.schema.billPaymentsSchema.schema.dueDate.min = this.businessDate
                // this.schema.billPaymentsSchema.model.dueDate = this.$formatter.formatDate(this.businessDate)
                this.schema.billPaymentsSchema.model.companyId = this.config.chargeInfo.companyId
                this.schema.billPaymentsSchema.model.customerId = this.config.chargeInfo.customerId
                // this.schema.billPaymentsSchema.model.reference = this.config.chargeInfo.reference
                this.schema.billPaymentsSchema.model.billAmount = this.config.chargeInfo.billAmount
                this.schema.billPaymentsSchema.model.debitAccountNumber = this.config.chargeInfo.debitAccountNumber
                this.validityCheck()
              }
              if (this.config && this.config.additionalProps && this.config.additionalProps.length) {
                this.config.additionalProps.forEach((key, index) => {
                  this.existingFields.push(key.fieldName)
                  this.addDynamicFields(key, index)
                })
              } else {
                this.existingFields = []
              }
              this.renderComponent = true
            }, 100)
          }, 100)
        }
      }
    },
    navigateToHistory () {
      this.$router.push({ path: '/billPayment' })
    },
    newBillPayment () {
      this.$router.push({ path: '/newBillPayment' })
    },
    async getFormData (formName) {
      try {
        const componentSchema = await CommonService.getFormData(formName)
        const data = getFormConfig(componentSchema)
        this.schema.billPaymentsSchema = data
        if (data && !this.newBillerTemplate) {
          this.loadPreviousTemplate()
        }
        event.$on('isValid', (arg) => {
          this.valid = !arg
        })
      } catch (e) {
        console.log(e)
      }
    },
    async getListofAccounts () {
      try {
        if (this.listOfAccounts && !this.listOfAccounts.length && !this.accountsExist) {
          this.accountsExist = true
          this.listOfAccounts = await preload.getAccountsWithBalance(
            JSON.parse(sessionStorage.getItem('username'))
          )
        }
        this.schema.billPaymentsSchema.schema.debitAccountNumber.items = this.filterDisplay()
      } catch (e) {
        console.log(e)
      }
    },
    filterDisplay () {
      if (this.listOfAccounts.length) {
        this.validAccountsList = []
        this.listOfAccounts.forEach((key, index) => {
          if (key.postingsRestriction !== 'DEBIT' && key.currency === this.billerCurrency && ['CACC', 'SVGS'].includes(key.accountType) &&
          !(key.accountOwnership === 'JOINT' && this.$appSettings.uiFieldsDisplayConfigurations.jointModeOfOperationsForTransfer.exclusionList.includes(key.modeOfOperation.code))) {
            this.validAccountsList.push({
              text: `${key.accountType === 'CACC' ? 'Current' : 'Savings'}` + ' ' + '-' + ' ' + key.accountId + ' ' + '-' + ' ' + this.$t('common.balLabel') + ' ' + this.$formatter.currency.format(key.balance, key.currency),
              value: key.accountId,
              balance: key.balance
            })
          }
        })
        return this.validAccountsList
      } else return undefined
    },

    navigateWindow () {
      if (this.newBillerTemplate) {
        this.renderComponent = false
        this.step = 1
      } else {
        if (store.getters['userStore/userData'].repeatHistoryConfig && store.getters['userStore/userData'].repeatHistoryDisplay && store.getters['userStore/userData'].repeatHistoryParams) {
          this.renderComponent = false
          event.$emit('repeatHistoryConfig', store.getters['userStore/userData'].repeatHistoryConfig)
        } else {
          this.renderComponent = false
          event.$emit('navigateToRepeatPayment', true)
        }
      }
    },

    async getAccountDetails (accountId) {
      const response = await CommonService.getAccountDetails(accountId)
      switch (response.accountType) {
        case 'SVGS':
          this.chargeInfo.fromAccountType = 'Savings' + ' ' + '-' + ' ' + accountId
          break
        case 'CACC':
          this.chargeInfo.fromAccountType = 'Current' + ' ' + '-' + ' ' + accountId
          break
      }
    },

    async calculateCharges () {
      this.chargeInfo = this.schema.billPaymentsSchema.model
      if (this.chargeInfo.debitAccountNumber) {
        await this.getAccountDetails(this.chargeInfo.debitAccountNumber)
      }
      this.dueDate = this.chargeInfo.dueDate.split('-').reverse().join('-')
      if (this.newBillerTemplate) {
        this.chargePayload = {
          customerId: JSON.parse(sessionStorage.getItem('username')),
          sourceId: 'DIGITAL-CHANNEL',
          billDetails: {
            id: this.billerData[0].id,
            customerId: this.chargeInfo.customerId,
            reference: this.chargeInfo.reference,
            amount: Number(this.chargeInfo.billAmount),
            dueDate: this.dueDate,
            additionalData: []
          }
        }
        if (this.billerData && this.billerData.length && this.billerData[0].additionalDataRequired && this.billerData[0].additionalDataRequired.length) {
          this.billerData[0].additionalDataRequired.forEach((key, index) => {
            this.chargePayload.billDetails.additionalData.push({
              'custom-fields': {}
            })
          })
        }
        if (this.additionalFields.length) {
          this.additionalFields = this.additionalFields.filter(function (item, index, inputArray) {
            return inputArray.indexOf(item) === index
          })
          this.additionalFields.forEach((key, index) => {
            this.chargePayload.billDetails.additionalData[index]['custom-fields'] = {
              [key]: ''
            }
          })
          this.additionalFields.forEach((key, index) => {
            this.chargePayload.billDetails.additionalData[index]['custom-fields'] = {
              [key]: this.chargeInfo[key]
            }
            this.chargePayload.billDetails.additionalData[index]['custom-fields'] = {
              [key]: this.chargeInfo[key]
            }
          })
        }
      } else {
        this.chargePayload = {
          customerId: JSON.parse(sessionStorage.getItem('username')),
          sourceId: 'DIGITAL-CHANNEL',
          billDetails: {
            id: this.config.chargeInfo.billerTemplateId,
            customerId: this.chargeInfo.customerId,
            reference: this.chargeInfo.reference,
            amount: Number(this.chargeInfo.billAmount),
            dueDate: this.dueDate,
            additionalData: []
          }
        }
        if (this.config && this.config.chargeInfo && this.config.chargeInfo.additionalData && this.config.chargeInfo.additionalData[0] && this.config.chargeInfo.additionalData[0]['custom-fields']) {
          const extraFields = Object.keys(this.config.chargeInfo.additionalData[0]['custom-fields'])
          this.existingFields = [...new Set([...this.existingFields, ...extraFields])]
          // this.existingFields = this.existingFields
          this.existingFields.forEach((key, index) => {
            this.chargePayload.billDetails.additionalData.push({
              'custom-fields': {}
            })
          })
          this.existingFields.forEach((key, index) => {
            this.chargePayload.billDetails.additionalData[index]['custom-fields'] = {
              [key]: this.chargeInfo[key]
            }
            this.chargePayload.billDetails.additionalData[index]['custom-fields'] = {
              [key]: this.chargeInfo[key]
            }
          })
        } else if (this.existingFields.length) {
          this.existingFields.forEach((key, index) => {
            this.chargePayload.billDetails.additionalData.push({
              'custom-fields': {}
            })
          })
          this.existingFields.forEach((key, index) => {
            this.chargePayload.billDetails.additionalData[index]['custom-fields'] = {
              [key]: this.chargeInfo[key]
            }
            this.chargePayload.billDetails.additionalData[index]['custom-fields'] = {
              [key]: this.chargeInfo[key]
            }
          })
        }
      }
      const chargeDetails = await CommonService.getPaymentCharges(this.chargePayload)
      // if (chargeDetails && chargeDetails.chargeDetails && chargeDetails.chargeDetails[0]) {
      if (chargeDetails && !chargeDetails.causes) {
        this.additionalFormValues = []
        store.dispatch('userStore/setUserData', {
          repeatHistoryParams: true
        })
        if (this.chargePayload && this.chargePayload.billDetails && this.chargePayload.billDetails.additionalData && this.chargePayload.billDetails.additionalData.length > 0) {
          this.chargePayload.billDetails.additionalData.forEach((key, index) => {
            this.additionalFormValues.push(Object.values(key['custom-fields']))
          })
        }
        if (this.additionalFormValues && this.additionalFormValues.length) {
          this.additionalFormValues = [].concat.apply([], this.additionalFormValues)
        }
        this.step++
        this.chargeResponse = chargeDetails
        this.display = {
        // charge: chargeDetails.chargeDetails[0].customerChargeAmount,
        // totalAmount: Number(chargeDetails.chargeDetails[0].customerChargeAmount) + Number(chargeDetails.billAmount),
          dueDate: this.dueDate,
          id: this.chargePayload.billDetails.id,
          customerId: this.chargePayload.billDetails.customerId,
          reference: this.chargePayload.billDetails.reference,
          otherFields: this.chargePayload.billDetails.additionalData,
          paymentDate: this.businessDate,
          additionalKeyDescription: this.additionalDescription,
          additionalValues: this.additionalFormValues,
          customDataMap: this.customDataMap
        }
        if (!this.additionalFields.length && this.newBillerTemplate) {
          this.display.additionalKeyDescription = []
          this.display.additionalValues = []
        }
        if (!this.existingFields.length && !this.newBillerTemplate) {
          this.display.additionalKeyDescription = []
          this.display.additionalValues = []
        }
        if (chargeDetails) {
          this.display.charge = chargeDetails.totalChargeAmount
          this.display.totalAmount = chargeDetails.paymentAmount
        }
        if (this.display && this.display.customDataMap.length) {
          this.display.customDataMap.forEach(key => {
            this.chargePayload.billDetails.additionalData.forEach(ele => {
              const objectKeys = Object.keys(ele['custom-fields'])
              if (key.name === objectKeys.toString()) {
                key.subtitle = ele['custom-fields'][key.name]
              }
            })
          })
        }
        this.reviewScreen = true
        if (!this.newBillerTemplate) {
          this.display.repeatBillPayment = true
          this.display.updatedSummary = true
          event.$emit('repeatHeaders', this.display)
        } else {
          this.display.updatedSummary = true
        }
        event.$emit('repeatSummary', this.display, { chargeInfo: this.chargeInfo || this.config.chargeInfo })
      }
    }
  },
  watch: {
    config: {
      handler (val) {
        /* eslint-disable-next-line */
        if (val && val.chargeInfo.billerTemplateId) {
          this.listOfAccounts = []
          this.accountsExist = false
          this.getListofAccounts()
        }
      },
      deep: true
    }
  }
}
</script>
